import { ApolloClient, ApolloError } from "@apollo/client"
import { FormikErrors } from "formik"
import { CHECK_FILE_NAME } from "../../../queries/CHECK_FILE_NAME"
import { BatchItem } from "../BatchItem"
import { FormValues, ValidationErrorMessages } from "./interfaces"
import {
    fileNameExistsValidationSchema,
    sourceTextValidationSchema,
    targetTextValidationSchema
} from "./ValidationSchemas"

export function isDuplicateName(name: string, item: BatchItem, batchItems: BatchItem[]) {
    const items = batchItems.filter(o => o.index !== item.index && o.include)
    return items.filter(x => x.name === name).length > 0
}

export function validateNameUnique(
    values: FormValues,
    errors: FormikErrors<FormValues>,
    item: BatchItem,
    items: BatchItem[]
): void {
    if (isDuplicateName(values.name, item, items)) {
        errors.name = ValidationErrorMessages.DUPLICATE_FILE_NAME
    }
}

export async function checkFileName(
    values: FormValues,
    errors: FormikErrors<FormValues>,
    client: ApolloClient<object>
): Promise<void> {
    const query = client
        .query({
            variables: { checkFileNameInput: { fileName: values.name } },
            query: CHECK_FILE_NAME,
            fetchPolicy: "network-only"
        })
        .catch((err: ApolloError) => {
            errors.name = err.message
        })

    await query
}

export async function validateFilenameExists(
    values: FormValues,
    errors: FormikErrors<FormValues>
): Promise<void> {
    await fileNameExistsValidationSchema.validate(values.name).catch(e => (errors.name = e.message))
}

export async function validateSourceTextLength(
    values: FormValues,
    errors: FormikErrors<FormValues>
) {
    await sourceTextValidationSchema.validate(values.source).catch(e => (errors.source = e.message))
}

export async function validateTargetTextLength(
    values: FormValues,
    errors: FormikErrors<FormValues>
) {
    await targetTextValidationSchema.validate(values.target).catch(e => (errors.target = e.message))
}

export function formHasValidationErrors(errors: FormikErrors<FormValues>): boolean {
    if (errors === undefined) return false
    return !!(errors.name || errors.source || errors.target)
}

export function formHasValidationOrOperationErrors(errors: FormikErrors<FormValues>): boolean {
    return Object.values(errors).some(msg => !!msg)
}

export function getTooltipErrorMsg(errors: FormikErrors<FormValues>): string {
    return errors.rowIcon || Object.values(errors).filter(msg => !!msg)[0] || ""
}

export function getErrorMsgs(errors: FormikErrors<FormValues>): string {
    return Object.values(errors)
        .filter(msg => !!msg)
        .join(", ")
}
